/**
* Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
* Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
* Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
*/
import { combineReducers } from 'redux';
import machineListFilter from './machineListFilter';
import softwareListFilter from './softwareFilter';
import commonListFilter from './commonFilter';
import machines from './machines';
import fairs from './fairs';
import softwares from './softwares';
import user from './user';

export default combineReducers({ commonListFilter, softwareListFilter, machineListFilter, machines, fairs, softwares, user });